import {COMPANY_ROLES_OBJECT} from "constants.js";
import {generateFullUrl} from "services/utils/utils";

export const People = {
    fromCompany: (data) => {
        return {
            name: data.business_name,
            skills: data.skills || [],
            text: data.sector,
            user_id: data.owner.id,
            user_slug: data.owner.slug,
            company_id: data.id,
            type: "company",
            id: data.id,
            favorite: data.is_favourite,
            plan: data.owner.subscription_type || null,
            avatar: generateFullUrl(data.logo)
        }
    },
    fromProfile: (data) => {
        return {
            name: `${data.first_name} ${data.last_name}`,
            skills: data.skills || [],
            text: `${COMPANY_ROLES_OBJECT[data.company.role] || data.company.role} @${data.company.name}`,
            user_id: data.id,
            user_slug: data.slug,
            company_id: null,
            type: "user",
            id: data.id,
            favorite: data.is_favourite,
            plan: data.subscription_type || null,
            avatar: generateFullUrl(data.avatar)
        }
    }
}